export const getSelectedSpeaker = (state) => state.devices.selectedSpeaker;
export const getSelectedCamera = (state) => state.devices.selectedCamera;
export const getRemoteCameras = (state) => state.devices.remoteCameras;
